import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, Tooltip, Typography } from '@material-ui/core';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useTranslation } from 'react-i18next';
import { NAME_SPACE } from 'i18n';
import { useCustomAudioFileStyles } from './customAudioFile.styles';

export function CustomAudioFile({ src, label, readToken }) {
  const [source, setSource] = useState(src);
  const classes = useCustomAudioFileStyles();
  const { t } = useTranslation(NAME_SPACE.COMMON);

  useEffect(() => {
    setSource(`${src}${readToken ? `?${readToken}` : ''}`);
  }, [src, readToken]);

  return (
    <div className={classes.audioFileContainer}>
      <MusicNoteIcon className={classes.audioFileIcon} />
      <Link
        onClick={evt => evt.stopPropagation()}
        href={source}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.audioFileText}
      >
        <Typography variant="subtitle2">{label}</Typography>
        <Tooltip title={t('actions.open')}>
          <OpenInNewIcon className={classes.openIcon} />
        </Tooltip>
      </Link>
    </div>
  );
}

CustomAudioFile.propTypes = {
  src: PropTypes.string,
  label: PropTypes.string,
  readToken: PropTypes.string
};

export default CustomAudioFile;
